// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCet53SAeTY9foAZH9fVNnMFeoQwkN4aQo",
    authDomain: "yusef-b9696.firebaseapp.com",
    databaseURL: "https://yusef-b9696-default-rtdb.firebaseio.com",
    projectId: "yusef-b9696",
    storageBucket: "yusef-b9696.firebasestorage.app",
    messagingSenderId: "555572873539",
    appId: "1:555572873539:web:d2dd288ff70314228cc7f6",
    measurementId: "G-GB5040JZJ9"
};
  

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

let performanceInitializationPromise = Promise.resolve(null);

if (typeof window !== "undefined") {
    performanceInitializationPromise = import("firebase/performance")
        .then(async ({ getPerformance, isSupported }) => {
            const supported = await isSupported();

            if (!supported) {
                return null;
            }

            return getPerformance(app);
        })
        .catch((error) => {
            console.warn("Firebase Performance Monitoring could not be initialized.", error);
            return null;
        });
}

const initializeFirebasePerformance = () => performanceInitializationPromise;

const startPerformanceTrace = async (traceName) => {
    const performance = await performanceInitializationPromise;

    if (!performance) {
        return null;
    }

    const { trace } = await import("firebase/performance");
    const performanceTrace = trace(performance, traceName);

    performanceTrace.start();

    return performanceTrace;
};

export { app, db, initializeFirebasePerformance, startPerformanceTrace };
